
const posDisplayRatio = 3 / 4
export const posDisplaySize = {
  // width: 800,  
  width: 960,               // full page height
  ratio: posDisplayRatio,   // aspect ration  height/width
  headerHeight: 40,
  footerHeight: 30
}
